import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { WineryContextService } from '../../../services/winery-context.service';
import { AccountMenuComponent } from '../account-menu/account-menu.component';

/** The phone has no top bar: this strip carries the winery name and the account menu (Help, Sign out). It bleeds over the shell's page padding. */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-phone-header',
  standalone: true,
  imports: [TranslocoDirective, AccountMenuComponent],
  host: { class: 'block' },
  template: `
    <header *transloco="let t" class="-mx-4 -mt-4 mb-4 flex h-14 items-center justify-between gap-3 border-b border-border-default bg-surface px-4">
      <span class="truncate text-heading-md">{{ winery()?.name ?? t('nav.wineryFallback') }}</span>
      <app-account-menu />
    </header>
  `,
})
export class PhoneHeaderComponent {
  protected readonly winery = inject(WineryContextService).winery;
}
